import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const jobIsScheduled = (status: string) => {
  return JOB_STATUSES_ENUM[status as keyof typeof JOB_STATUSES_ENUM] === JOB_STATUSES_ENUM.JOB_STATUS_SCHEDULED;
};
